const closeShopMenu = (trigger) => {
  const headerMenu = trigger?.closest('header-menu');
  if (!headerMenu || typeof headerMenu.deactivate !== 'function') return;

  headerMenu.deactivate({
    target: trigger,
    relatedTarget: null,
    type: 'blur',
  });
};

if (!window.__pmRemakeShopMenuInitialized) {
  window.__pmRemakeShopMenuInitialized = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const backdrop = event.target.closest('.pm-shop-menu__backdrop');
    if (!backdrop) return;

    const trigger = backdrop.closest('.pm-shop-menu-item')?.querySelector('[ref="menuitem"]');
    closeShopMenu(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const trigger = document.querySelector('.pm-shop-menu-item [ref="menuitem"][aria-expanded="true"]');
    if (!trigger) return;

    event.preventDefault();
    closeShopMenu(trigger);
    trigger.focus();
  });
}
